import {useEffect} from "react";

import {boosterTracking} from "../tracking/booster_tracking";
import {IBoosterSegments} from "../types/IBoosterSegments";
import {IBoosterMetadata} from "./use_booster";

interface IUseBoosterAnalyticsProps<TBoosterParams extends object> {
    segments: IBoosterSegments | null;
    metadata: IBoosterMetadata<TBoosterParams> | null;
}

export const useBoosterAnalytics = <TBoosterParams extends object>(props: IUseBoosterAnalyticsProps<TBoosterParams>) => {
    useEffect(() => {
        if (props.metadata?.boosterText && props.metadata?.category && props.metadata?.type) {
            boosterTracking.gtm.trackBoosterView(props.metadata.boosterText, props.metadata.category, props.metadata.type);
        }
    }, [props.metadata?.category, props.metadata?.type]);

    return {
        trackBoosterClick: () => {
            if (props.metadata?.boosterText && props.metadata?.category && props.metadata?.type) {
                boosterTracking.gtm.trackBoosterClick(props.metadata.boosterText, props.metadata.category, props.metadata.type);
            }
        }
    };
};
import {useEffect} from "react";

import {boosterTracking} from "../tracking/booster_tracking";
import {IBoosterSegments} from "../types/IBoosterSegments";
import {IBoosterMetadata} from "./use_booster";

interface IUseBoosterAnalyticsProps<TBoosterParams extends object> {
    segments: IBoosterSegments | null;
    metadata: IBoosterMetadata<TBoosterParams> | null;
}

export const useBoosterAnalytics = <TBoosterParams extends object>(props: IUseBoosterAnalyticsProps<TBoosterParams>) => {
    useEffect(() => {
        if (props.metadata?.boosterText && props.metadata?.category && props.metadata?.type) {
            boosterTracking.gtm.trackBoosterView(props.metadata.boosterText, props.metadata.category, props.metadata.type);
        }
    }, [props.metadata?.category, props.metadata?.type]);

    return {
        trackBoosterClick: () => {
            if (props.metadata?.boosterText && props.metadata?.category && props.metadata?.type) {
                boosterTracking.gtm.trackBoosterClick(props.metadata.boosterText, props.metadata.category, props.metadata.type);
            }
        }
    };
};
